module.exports = __webpack_public_path__ + "img/Beowulf_i_kamp_med_draken.f5da9d5b.jpg";